angular.module('CarsSaraBo').controller('ModificationPoliciesController', ['$scope', '$routeParams','$q','ModificationPolicyService',
                                                  function($scope, $routeParams,$q,modificationPolicyService) {
	
	$scope.initialize = function() {
		$scope.checkBoxModel = {"ids":{}}
		$scope.listModificationPolicies = ["PU_DATE", "DO_DATE", "PU_LOCATION", "DO_LOCATION", "CAR"];
		$scope.loadCompany();
		$scope.editableModificationPolicies = $scope.loggedUserAllowed('PERM_BOOKING_MODIFICATION_POLICY_CREATE') || $scope.loggedUserAllowed('PERM_BOOKING_MODIFICATION_POLICY_EDIT') ||  $scope.loggedUserAllowed('PERM_BOOKING_MODIFICATION_POLICY_DELETE'); 
	}
	
	$scope.loadCompany = function(){
		$scope.modificationPolicy = {};
		modificationPolicyService.get({companyOid: $routeParams.oid }, function(response) {
			$scope.modificationPolicy = response[0];
			$scope.initCheckbox(response[0].allowedModifications);
		});
	}

	$scope.initCheckbox = function(list){
		list.forEach(function(e) {
			$scope.checkBoxModel.ids[e.modificationType]=true;	
		});
	}
	
	$scope.cancel = function(){
		$scope.showModal("CANCEL_ALERT_TITLE", "CANCEL_ALERT_DESCRIPTION", function() {
			$scope.initialize();
		});
		
	}
	
	$scope.save = function(){
		$scope.mergeAllowedModificationsList($scope.listModificationPolicies);
		$q.all([
				modificationPolicyService.save({"companyOid":$routeParams.oid},$scope.modificationPolicy).$promise
			]).then(function(response) {
				$scope.initialize();
				$scope.notifyInfoByCode('modification_policies.confirmationMessage.SUCCESS');
			});
	}
	
	$scope.mergeAllowedModificationsList = function(list){
		$scope.modificationPolicy.allowedModifications = [];
		list.forEach(function(e) {
			if($scope.checkBoxModel.ids[e] != undefined && $scope.checkBoxModel.ids[e]==true){
				$scope.modificationPolicy.allowedModifications.push({"modificationType":e});
			}
		});
	}	
	$scope.initialize();
}]); 


//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/general_conditions_controllers/modification_policies_controller.js
// module id = 914
// module chunks = 3